import * as React from 'react';
import { usePerformAction } from 'react-remote-data-hooks';
import api from '../../../../api';
import { AutolineSettings } from '../../../../core';
import UpdateForm from './UpdateForm';

interface IAutolineSettingsProps {
  data?: AutolineSettings;
  reload?: () => void;
}

const AutolineSettingsTab: React.FunctionComponent<IAutolineSettingsProps> = (
  props
) => {
  const [editModalOpen, setEditModalOpen] = React.useState(false);

  const {
    performAction: update,
    error: updateError,
    isPerforming: updating,
  } = usePerformAction(
    (data: AutolineSettings) => api.settings.updateAutolineSettings(data),
    () => {
      props.reload?.();
      setEditModalOpen(false);
    }
  );

  return (
    <>
      <div className="col-lg-4 col-md-6 col-12 border-right">
        <div className="d-flex align-items-center py-3">
          <div className="col">
            <h4 className="mb-0 font-weight-semibold">Autoline Settings</h4>
          </div>
          <div className="col-auto text-right">
            <button
              className="btn btn-link font-normal font-weight-semibold px-2 py-2 d-inline-flex align-items-center"
              onClick={() => setEditModalOpen(true)}
            >
              <i className="icon-edit mr-1 font-xs"></i> Edit
            </button>
          </div>
        </div>
        <div className="grid-table grid-table--sm border-top">
          <table>
            <thead>
              <tr>
                <th>
                  <span className="d-inline-flex align-items-center">Name</span>
                </th>
                <th>
                  <span className="d-inline-flex align-items-center">
                    Value
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>API Key</td>
                <td>{props.data?.apiKey && '********************'}</td>
              </tr>
              <tr>
                <td>Base URL</td>
                <td>{props.data?.baseUrl}</td>
              </tr>
              <tr>
                <td>Brand Name</td>
                <td>{props.data?.brandName}</td>
              </tr>
              <tr>
                <td>Customer Brand Name</td>
                <td>{props.data?.customerBrandName}</td>
              </tr>
              <tr>
                <td>API Encryption Key</td>
                <td>{props.data?.apiEncryptionKey && '***********'}</td>
              </tr>
              <tr>
                <td>Default Salesman HR System ID</td>
                <td>{props.data?.defaultSalesmanHrSystemId}</td>
              </tr>
              <tr>
                <td>Default Source Of Business</td>
                <td>{props.data?.defaultSourceOfBusiness}</td>
              </tr>
              <tr>
                <td>Campaign Discount Autoline Code</td>
                <td>{props.data?.campaignDiscountAutolineCode}</td>
              </tr>
              <tr>
                <td>Accessories Discount Autoline Code</td>
                <td>{props.data?.accessoriesDiscountAutolineCode}</td>
              </tr>
              <tr>
                <td>CashBackDiscount Discount Autoline Code</td>
                <td>{props.data?.cashBackDiscountAutolineCode}</td>
              </tr>
              <tr>
                <td>Coupon Discount Autoline Code</td>
                <td>{props.data?.couponDiscountAutolineCode}</td>
              </tr>
              <tr>
                <td>Adjustments Autoline Code</td>
                <td>{props.data?.adjustmentsAutolineCode}</td>
              </tr>
              <tr>
                <td>Listing Price Autoline Code</td>
                <td>{props.data?.listingPriceAutolineCode}</td>
              </tr>
              <tr>
                <td>Finance Commission Autoline Code</td>
                <td>{props.data?.financeCommissionMenuCode}</td>
              </tr>
              <tr>
                <td>Vehicle Combination List Starting Year</td>
                <td>{props.data?.vehicleFromYear}</td>
              </tr>
              <tr>
                <td>Vin Discount Autoline Code</td>
                <td>{props.data?.vinDiscountAutolineCode}</td>
              </tr>
              <tr>
                <td>Extra AddOn Autoline Code</td>
                <td>{props.data?.extraAddOnMenuCode}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="col-lg col-md-6 col-12 p-2 setting-detail-block left-0 top-0 bg-white w-100 h-100 zIndex-1">
        {editModalOpen && (
          <>
            <div className="text-right d-md-none">
              <i className="icon-close"></i>
            </div>
            <UpdateForm
              onSubmit={(formData) => update(formData)}
              isSubmitting={updating}
              error={updateError?.message}
              data={props.data}
              onCancel={() => setEditModalOpen(false)}
            ></UpdateForm>
          </>
        )}
      </div>
    </>
  );
};

export default AutolineSettingsTab;
